const radConfig = {
  allottement_status: false,
  currentUrl: "https://addannex.aikenist.com/",
  baseUrl: "https://addannex.aikenist.com/api/quickrad",
  baseUrlRadio: "https://addannex.aikenist.com/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://addannex.aikenist.com/aikenviewer/viewer/",
  viewer3DURL:"https://addannex.aikenist.com/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://addannex.aikenist.com/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://addannex.aikenist.com/3daikenviewer/microscopy?StudyInstanceUIDs=",  
  viewerMultiple: "https://addannex.aikenist.com/3daikenviewer/viewer?",
  medDream:"https://addannex.aikenist.com/?study=",
  thumbnailURL: "https://addannex.aikenist.com/dicom-web/instances/",
  gifURL:
  "https://addannex.aikenist.com/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://addannex.aikenist.com/dicom-web",
  weasisDicomWeb: "https://addannex.aikenist.com/dicom-web",
  studyList: "https://addannex.aikenist.com/dicom-web/studies",
  localViewer: "https://addannex.aikenist.com/aikenviewer/local",
  client: "addannex",
  paymentComplete: true,
  version: "v2.0",
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp"
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
